<template>
  <div class="content component-users">
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item">
        <a href="javascript:;">Home</a>
      </li>
      <li class="breadcrumb-item active">{{ $t('declarations.subtitle') }}</li>
    </ol>
    <h1 class="page-header">
      {{ $t('app.name') }}
      <small>{{ $t('declarations.subtitle') }}</small>
    </h1>

    <b-row>
      <b-col cols="12">
        <ct-declaration-widget/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CtDeclarationWidget from '@/components/Declarations/DeclarationsWidget.vue';

export default {
  name: 'Declarations',
  components: {
    CtDeclarationWidget,
  },
};
</script>

<style scoped lang="scss">

</style>
